import * as yup from "yup";
import { validationArraySelect, validationNotEmpty, validationStringSelect } from "./defaultValidations";

export default yup.object({
  key: validationStringSelect("Key"),
  algorithm: validationStringSelect("Algorithm"),
  inputVal: validationNotEmpty("Plain Text"),
});
